import {CONSTANTS} from './enum-constants'
import {headerName} from '@telstra-connect/utils/helper/common-static-data'
import {IStrategicServiceDetailsResponse} from '@telstra-connect/mobile-data-usage-meter/query-methods/strategic-service-details'
import {useLocation, useNavigate} from 'react-router-dom'

export const getValidDaysRemainingValue = (val) => {
  if (isNaN(val)) {
    return 0
  }

  if (Number(val) < 0) {
    return 0
  }

  return val
}

export const isValidBillingDate = (billingDate) => {
  if (billingDate !== undefined && billingDate !== '' && !billingDate?.includes('0001')) {
    return true
  }
  return false
}

export const isEWPlan = (planTypeCode) => planTypeCode === CONSTANTS.PLAN_TYPE_CODE.EW

export const RedirectToMobility = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = window.location.search
  const url = location.pathname.replace('mobile-data-usage-meter', 'mobility')
  navigate(url + queryParams)
  return null
}

export const checkApplicationAccess = (appName) => {
  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  const applicationServicesConfig = window?.['applications']?.[appName]
  return !applicationServicesConfig ? false : true
}

export const isUserReadOnly = () => {
  return (
    global.applications[CONSTANTS.REQUEST_MANAGEMENT]?.customProperties &&
    global.applications[CONSTANTS.REQUEST_MANAGEMENT]?.customProperties.roles ===
      headerName.readOnlyUser
  )
}

export const isBoltOnApplied = (StrategicServiceDetailsData: IStrategicServiceDetailsResponse) => {
  return StrategicServiceDetailsData?.usageAllowance?.some((item) => {
    return (
      item?.balanceId === CONSTANTS.FAIR_USAGE.unshapeBoltOnbalanceId ||
      item?.balanceId === CONSTANTS.FAIR_USAGE.dataTopUpBoltOnbalanceId ||
      item?.allowanceType === CONSTANTS.ALLOWANCE_TYPE.UNSHAPED_BOLT_ON ||
      item?.allowanceType === CONSTANTS.ALLOWANCE_TYPE.AUTO_DATA_TOP_UP
    )
  })
}
